import React, { useState } from 'react'
import Dropzone from 'react-dropzone'
import styled from 'styled-components'
import { Comment, Error } from './Text'
import Icon from './Icon'
import LabelField from './LabelField'
import theme from '../utils/theme'

const UploaderContainer = styled(LabelField)`
  .input{
    background: transparent;
    color: ${ theme.palette.black };
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    font-size: 14px;
    flex-direction: column;
    > div {
      display: flex;
      align-item: center;
      margin: 5px 0;
    }
  }
  .loading {
    margin-right: 15px;
  }
  .btn {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 10px;
    color: ${ theme.palette.black };
  }
  .btn svg {
    margin-right: 15px;
  }
  > .description {
    white-space: pre-wrap;
    span {
      font-weight: bold;
    }
  }
  @media (max-width: ${ theme.breakpoints.mobile }) {
    .input{
      background: transparent;
      border-radius: 0px;
      flex-wrap: wrap;
      height: auto;
      padding: 0;
    }
  }
`
const Uploader = ({
                    label,
                    subLabel,
                    optional,
                    required,
                    description,
                    onFileUpload,
                    onFileDelete,
                    onFileClick,
                    onSuccess,
                    onError,
                    value,
                    className = '',
                    maxSize,
                    disabled,
                    accept,
                    multiple,
                    children,
                    ...props
                  }) => {
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(null)
  const [fileName, setFileName] = useState(null)
  const onDrop = async acceptedFiles => {
    const file = acceptedFiles[0]
    if (maxSize && file.size > maxSize * 1048576) {
      setError(`La taille max de fichier est ${ maxSize } Mo`)
      onError && onError(`La taille max de fichier est ${ maxSize } Mo`)
      return
    }
    if (accept) {
      const list = accept.split(',')
      const canAccept = list.reduce((previous, item) => {
        if (!previous) {
          const nameList = file.name.split('.')
          const extension = '.' + nameList[nameList.length - 1]
          return extension.toLowerCase() === item.trim().toLowerCase()
        } else {
          return previous
        }
      }, false)
      if (!canAccept) {
        setError(`Seuls les fichiers ${ accept } sont acceptés`)
        onError && onError(`Seuls les fichiers ${ accept } sont acceptés`)
        return
      }
    }
    setLoading(true)
    setFileName(file.name)
    if (onFileUpload) {
      try {
        await onFileUpload(file)
        setError('')
        onSuccess && onSuccess()
      } catch (e) {
        setError(e.message)
        onError && onError(e.message)
      }
      setLoading(false)
      setFileName(null)
    }
  }

  const canUpload = !loading && onFileUpload && !disabled && (!value || multiple)
  const list = value ? (Array.isArray(value) ? value : [value]) : null
  return (
    <UploaderContainer className={ 'uploader ' + className } label={ label } subLabel={ subLabel } optional={optional} required={required}>
      { description && <Comment className='description'>{description}</Comment> }
      <div className="input">
        {
          list && list.map((v, index) => <FileLine key={ 'file' + index } value={ v } onFileDelete={ onFileDelete }
                                                   onFileClick={ onFileClick }
                                                   disabled={ disabled }/>)
        }
        {
          loading && <div><Icon name="loading" fill={ theme.palette.green }/>
            { fileName }
          </div>
        }
        {
          canUpload && <Dropzone onDrop={ onDrop }>
            { ({ getRootProps, getInputProps }) =>
              <div { ...getRootProps() } className="btn">
                <Icon name="add_circle" stroke={ theme.palette.black }/>
                Prendre en photo ou télécharger le fichier
                <input { ...getInputProps() } type="file"
                       accept={ accept }
                       multiple={ false }
                       { ...props }/>
              </div>
            }
          </Dropzone>
        }
      </div>
      {
        error && <Error>
          { error }
        </Error>
      }
      {
        children
      }
    </UploaderContainer>
  )
}
export default Uploader

const FileLineContainer = styled.div`
  > span {
    ${ props => props.canFileClick ? 'text-decoration: underline; cursor: pointer;' : ''}
    word-break: break-all;
  }
  .check_circle {
    width: 20px;
    height: 20px;
    margin-right: 15px;
    cursor: pointer;
  }
  .trash {
    margin-left: 15px;
    cursor: pointer;
  }
  .audited_file {
    color: red;
  }
`
const FileLine = ({ onFileDelete, onFileClick, disabled, value }) => {
  return <FileLineContainer className='file-line' canFileClick={onFileClick}>
    <Icon name="check_circle" fill={ theme.palette.green }/>
    <span className={ value.audited && !value.auditOk ? 'audited_file' : '' } onClick={ () => onFileClick && onFileClick(value) }>{ value.name }</span>
    { (onFileDelete && !disabled) &&
    <Icon name="trash" onClick={ () => onFileDelete(value) } fill={ theme.palette.black }/> }
  </FileLineContainer>
}
